// equivalencies/constants.js
// Conversion factor constants for environmental equivalencies

/**
 * Energy conversion factors
 */
export const BTU_PER_GALLON = 120214; // EIA average calorific value (Btu/gal)
export const BOTTLE_BTU = 1228; // 1 plastic bottle ≈ 0.36 kWh = 1,228 Btu

/**
 * GHG conversion factors
 */
export const CO2_PER_CAN_G = 98.7; // Each aluminum can recycled ≈ 98.7 g CO2e avoided
export const CO2_PER_TREE_10Y_MT = 0.60; // 1 tree (10 years) ≈ 0.60 t CO2

/**
 * Unit conversion constants
 */
export const MILLION = 1e6;
export const GRAMS_PER_METRIC_TON = 1e6;

/**
 * Equivalency metadata for display
 */
export const EQUIVALENCY_METADATA = {
  gasoline: {
    title: 'Gasoline Equivalent',
    unit: 'gallons',
    icon: '⛽',
    description: 'Energy equivalent in gasoline consumption',
    category: 'energy'
  },
  plasticBottles: {
    title: 'Plastic Bottles',
    unit: 'bottles',
    icon: '🧴',
    description: 'Energy equivalent in plastic bottle recycling',
    category: 'energy'
  },
  aluminumCans: {
    title: 'Aluminum Cans',
    unit: 'cans',
    icon: '🥫',
    description: 'GHG equivalent in aluminum can recycling',
    category: 'ghg'
  },
  treeSeedlings: {
    title: 'Tree Seedlings (10Y)',
    unit: 'trees',
    icon: '🌱',
    description: 'Carbon sequestration by tree seedlings over 10 years',
    category: 'ghg'
  }
};

/**
 * Conversion factor sources and references
 */
export const CONVERSION_SOURCES = {
  gasoline: 'EIA average calorific value (120,214 Btu/gal)',
  plasticBottles: 'Plastic bottle energy content (~0.36 kWh = 1,228 Btu)',
  aluminumCans: 'Aluminum can recycling avoidance (98.7 g CO2e/can)',
  treeSeedlings: 'Tree seedling carbon sequestration over 10 years (0.60 t CO2/tree)'
};
